import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import api from '../utils/api';

const ParametrageFraisModal = ({ open, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    frais_preparation: '',
    frais_livraison: '',
  });

  useEffect(() => {
    if (open) {
      fetchParametrage();
    }
  }, [open]);

  const fetchParametrage = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/parametrage');
      if (response.data) {
        setFormData({
          frais_preparation: response.data.frais_preparation !== undefined && response.data.frais_preparation !== null
            ? response.data.frais_preparation
            : '',
          frais_livraison: response.data.frais_livraison !== undefined && response.data.frais_livraison !== null
            ? response.data.frais_livraison
            : '',
        });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du paramétrage:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await api.put('/api/parametrage', formData);
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (error) {
      console.error('Erreur lors de la mise à jour du paramétrage:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Paramétrage des frais</DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <TextField
              label="Frais de préparation par défaut"
              type="number"
              fullWidth
              margin="dense"
              value={formData.frais_preparation}
              onChange={(e) =>
                setFormData({ ...formData, frais_preparation: e.target.value })
              }
              onBlur={(e) => {
                const val = e.target.value;
                setFormData({
                  ...formData,
                  frais_preparation:
                    val !== '' && !isNaN(val) ? Number(val).toFixed(2) : val,
                });
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>,
              }}
            />
            <TextField
              label="Frais de livraison par défaut"
              type="number"
              fullWidth
              margin="dense"
              value={formData.frais_livraison}
              onChange={(e) =>
                setFormData({ ...formData, frais_livraison: e.target.value })
              }
              onBlur={(e) => {
                const val = e.target.value;
                setFormData({
                  ...formData,
                  frais_livraison:
                    val !== '' && !isNaN(val) ? Number(val).toFixed(2) : val,
                });
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>,
              }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Annuler
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ParametrageFraisModal; 